import { getCurrencyIcon } from "@src/shared/getCurrencyIcon"
import css from "./index.module.css"

type Props = {
  network: string
  style?: React.CSSProperties
  symbol: string
}
export const CurrencyIcon = ({ network, style, symbol }: Props) => {
  const icon = getCurrencyIcon({ network, symbol })

  return (
    <div className={css.iconWrapper} style={{ ...style }}>
      <img alt={symbol} className={css.icon} src={icon} />
    </div>
  )
}
